module.exports = __webpack_public_path__ + "0ae174f3673c8088f51eaa52c845d827.svg";